var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareMegamenuIconReports = function SvgYeswareMegamenuIconReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8.5A4.5 4.5 0 0 0 10 13v10h.035a3.501 3.501 0 0 0 3.465 3H25a1 1 0 0 0 1-1V10a1.5 1.5 0 0 0-1.5-1.5h-10Zm-1 12h11v4h-11a2 2 0 1 1 0-4Zm8.02-6.959a.75.75 0 1 0-1.04-1.082l-2.605 2.501-1.356-1.301a.75.75 0 1 0-1.038 1.082l1.875 1.8a.75.75 0 0 0 1.038 0l3.125-3Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareMegamenuIconReports;